import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import colors from 'shared-components/theme/colors';
import { gilroyMedium } from 'shared-components/theme/fonts';
import Media from 'shared-components/theme/medias';
import styled from 'styled-components';
import gsap from 'gsap';

const GoesNavbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    // const [showNavbar, setShowNavbar] = useState(true);
    // const [lastScrollY, setLastScrollY] = useState(0);
    const menuItemsRef = useRef([]);
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
    const toggleMenu = () => {
        setIsOpen((prev) => !prev);
    };

    // useEffect(() => {
    //     const handleScroll = () => {
    //         const currentScroll = window.scrollY;

    //         if (currentScroll > lastScrollY && currentScroll > 30) {
    //             setShowNavbar(false); // scrolling down
    //         } else {
    //             setShowNavbar(true); // scrolling up
    //         }

    //         setLastScrollY(currentScroll);
    //     };

    //     window.addEventListener('scroll', handleScroll);
    //     return () => window.removeEventListener('scroll', handleScroll);
    // }, [lastScrollY]);

    useLayoutEffect(() => {
        if (isMobile && isOpen && menuItemsRef.current.length) {
            menuItemsRef.current.forEach((item, index) => {
                if (item) {
                    gsap.fromTo(
                        item,
                        { opacity: 0, y: 20 },
                        {
                            opacity: 1,
                            y: 0,
                            duration: 0.3,
                            delay: index * 0.05,
                            ease: 'power2.out',
                        }
                    );
                }
            });
        }

        if (!isOpen) {
            menuItemsRef.current = [];
        }
    }, [isOpen, isMobile]);

    const navItems = ['Home', 'Why PK', 'Talent', 'Cost', 'Tech', 'Results '];

    return (
        <Nav>
            <Hamburger onClick={toggleMenu} isOpen={isOpen}>
                <span />
                <span />
            </Hamburger>
            {isMobile && isOpen && (
                <>
                    <Backdrop onClick={toggleMenu} />
                    <NavWrapper>
                        {navItems.map((item, i) => (
                            <NavItem
                                key={item}
                                ref={(el) => (menuItemsRef.current[i] = el)}>
                                <NavLink
                                    onClick={toggleMenu}
                                    href={`#${item
                                        .toLowerCase()
                                        .replace(/\s/g, '')}`}>
                                    {item}
                                </NavLink>
                            </NavItem>
                        ))}
                    </NavWrapper>
                </>
            )}

            {/* Desktop Menu */}
            {!isMobile && (
                <NavWrapper>
                    {navItems.map((item, i) => (
                        <NavItem
                            key={item}
                            ref={(el) => (menuItemsRef.current[i] = el)}>
                            <NavLink
                                href={`#${item
                                    .toLowerCase()
                                    .replace(/\s/g, '')}`}>
                                {item}
                            </NavLink>
                        </NavItem>
                    ))}
                </NavWrapper>
            )}
        </Nav>
    );
};

export default GoesNavbar;

// styled-components
const Backdrop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(6px);
    background: rgba(0, 0, 0, 0.3); /* optional dark overlay */
    z-index: 9;
`;
const Hamburger = styled.div`
    // position: absolute;
    // right: 1.5rem;
    // top: 1.3rem;
    cursor: pointer;
    z-index: 20;
    width: 30px;
    height: 24px;
    display: none;
    margin-left: auto;

    span {
        display: block;
        height: 3px;
        background: ${colors.white[100]};
        margin-bottom: 6px;
        border-radius: 2px;
        transition: 0.3s ease;
    }

    span:last-child {
        margin-bottom: 0;
    }

    ${({ isOpen }) =>
        isOpen &&
        `
        span:first-child {
            transform: rotate(45deg) translateY(8px);
        }
        span:last-child {
            transform: rotate(-45deg) translateY(-7px);
        }
    `}

    ${Media('mobile')} {
        display: block;
        backdrop-filter: blur(5px) brightness(0.6);
        position: fixed;
        left: 12px;
        top: 100px;
        height: 40px;
        width: 40px;
        box-sizing: border-box;
        padding: 13px 8px;
        border-radius: 4px;
    }
`;

const Nav = styled.nav`
    position: relative;
    // position: sticky;
    // top: 103px;
    // background: white;
    transition: all 0.3s ease;
    // margin-top: ${(props) => (props.isVisible ? '0' : '-80px')};
    // opacity: ${(props) => (props.isVisible ? '1' : '0')};
    z-index: 99;
    background: transparent;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    ${Media('mobile')} {
        padding: 0;
        border-bottom: 0;
    }
`;

const NavWrapper = styled.ul`
    max-width: 556px;
    width: 100%;
    margin: auto;
    padding: 0;
    display: flex;
    justify-content: space-between;
    ${Media('large')} {
        max-width: 33.076vw;
    }
    ${Media('mobile')} {
        position: fixed;
        max-width: 90%;
        widht: 100%;
        height: 300px;
        flex-direction: column;
        top: 146px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;
        border-radius: 10px;
        background: ${colors.geoGreen[100]};
    }
`;
const NavItem = styled.li``;

const NavLink = styled.a`
    font-family: ${gilroyMedium};
    color: ${colors.white[100]};
    font-size: 16px;
    font-weight: 500;
    padding: 30px 20px;
    transition: 0.3s ease;
    position: relative;
    text-transform: uppercase;
    display: inline-block;
    ${Media('large')} {
        font-size: 0.952vw;
        padding: 1.785vw 1.19vw;
    }
    @media (max-width: 1680px) {
        padding: 16px;
    }
    ${Media('mobile')} {
        font-size: 14px;
    }

    &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 0%;
        height: 2px;
        background: ${colors.white[100]};
        transition: 0.3s ease;
    }

    &:hover {
        color: ${colors.white[100]};
    }
    &:hover::after {
        width: 100%;
    }
`;
